import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import omitProps from '../../../../utils/omitProps';

const TableUser = gql`
  fragment TableUser on User {
    id
    accounting_system_id
    firstname
    lastname
    payroll_type
    enabled
    default_district {
      id
      name
    }
    role
    cell_number
    email
    scanner
    hired_at {
      iso8601
    }
    terminated_at {
      date
      iso8601
    }
    supervisor {
      id
      fullname
      firstname
      lastname
    }
    default_department {
      id
      name
    }
    payment_system_id
  }
`;

const GetAllUsersQuery = gql`
  query GetAllUsers($excludeTerminatedUsers: Boolean) {
    all_users(exclude_salary: false, exclude_terminated: $excludeTerminatedUsers) {
      edges {
        node {
          ...TableUser
        }
      }
    }
  }
  ${TableUser}
`;

const marshallUserData = ({ ownProps, data }) => {
  const users = querySelector(data, '$.all_users.edges[*].node', []);
  const { loading } = data;
  return {
    ...ownProps,
    users,
    data,
    loading,
  };
};

const queryUserData = graphql(GetAllUsersQuery, {
  props: marshallUserData,
});

export const queryUsersGQL = compose(
  queryUserData,
  omitProps(['data']),
);

/* CREATE MUTATION */
const CreateUserMutation = gql`
  mutation CreateUser($input: UserCreateInput!) {
    user_create(input: $input) {
      ...TableUser
    }
  }
  ${TableUser}
`;

export const createUserMutationGQL = (client, user) => {
  const variables = {
    input: {
      ...user,
    },
  };

  const options = {
    mutation: CreateUserMutation,
    variables,
    refetchQueries: [
      { query: GetAllUsersQuery },
    ],
  };
  return client.mutate(options);
};

/* UPDATE MUTATION */
const UpdateUserMutation = gql`
  mutation UpdaterUser($input: UserUpdateInput!) {
    user_update(input: $input) {
      ...TableUser
    }
  }
    ${TableUser}
`;

export const updateUserMutationGQL = (client, user) => {
  const variables = {
    input: {
      ...user,
    },
  };

  const options = {
    mutation: UpdateUserMutation,
    variables,
    refetchQueries: [
      { query: GetAllUsersQuery },
    ],
  };
  return client.mutate(options);
};
